import { Link } from "@inertiajs/react"

export function PromoBanner() {
  return (
    <div className="relative isolate overflow-hidden bg-ink-950 text-white">
      <div
        className="absolute inset-y-0 right-0 -z-10 hidden w-1/2 bg-linear-to-l from-brand-700/30 via-brand-700/10 to-transparent sm:block"
        aria-hidden="true"
      />
      <div className="absolute inset-0 -z-10 dotted-grid-dark opacity-30" aria-hidden="true" />
      <div className="mx-auto flex w-full max-w-7xl items-center justify-center gap-x-2 px-4 py-2 text-center sm:gap-x-4 sm:py-2.5 lg:px-8">
        <p className="text-[0.8125rem] font-medium tracking-tight sm:text-sm">
          <span className="sm:hidden">Credits never expire.</span>
          <span className="hidden sm:inline">Credits never expire — buy a bundle, use it whenever.</span>
        </p>
        <Link
          href="/pricing"
          className="shrink-0 text-[0.8125rem] font-semibold tracking-tight text-brand-300 underline underline-offset-4 hover:text-brand-200 sm:text-sm"
        >
          See pricing →
        </Link>
      </div>
    </div>
  )
}
